import { graphql } from 'app/generated/gql'

import type { LocationJson } from 'app/types/entities'

/**
 * Shared between the inbox location picker (`useInboxLocations`, urql hook) and
 * the sidebar unread badge (`useSidebarCounts`, imperative `gqlQuery`). It lives
 * here so neither consumer has to reach into the other's module for it.
 */
export const INBOX_LOCATIONS_QUERY = graphql(`
  query InboxLocations($pagination: PaginationInput) {
    locations(pagination: $pagination) {
      hits {
        id
        name
        products
      }
    }
  }
`)

export type InboxLocationsResult = {
  locations: { hits: LocationJson[] }
}
